import React, { Component } from 'react';
import { Select } from 'antd';
import { filter as _filter } from 'lodash';
const Option = Select.Option;

export class ColumnToggle extends Component {
    state = {
        columnMaster: [],
        selectedColumns: [],
        allColumnsSelected: false
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.columnMaster.length === 0) {
            const state = this.state;
            state.columnMaster = nextProps.columns;
            state.selectedColumns = _filter(state.columnMaster, column => column.visible)
            state.allColumnsSelected = state.selectedColumns.length === state.columnMaster.length;
            this.setState(state);
        }
    }

    selectAllColumns = (column) => {
        if (column === "select_all") {
            const state = { ...this.state }
            state.allColumnsSelected = !state.allColumnsSelected;
            state.selectedColumns = state.allColumnsSelected ? state.columnMaster : [];
            state.columnMaster = state.columnMaster.map((x) => { 
                x.visible = state.allColumnsSelected; 
                return x; 
            });
            this.setState(state, () => {
                this.props.onChange(this.state.columnMaster);
            });
        }
    }

    oncolumnChange = (columnKeys) => {
        if (columnKeys.includes('select_all')) { return; }
        const state = {...this.state};
        state.selectedColumns = [];
        // let lead_table_selected_columns = [];
        state.columnMaster = state.columnMaster.map((x) => {
            x.visible = false;
            if(columnKeys.includes(x.key)) {
                state.selectedColumns.push(x);
                // lead_table_selected_columns.push(x);
                x.visible = true; 
            }
            return x;
        });
        state.allColumnsSelected = state.selectedColumns.length === state.columnMaster.length;
        this.setState(state, () => {
            this.props.onChange(this.state.columnMaster);
        });
    }

    renderColumnToggleButton(isEnabled) {
        if (!isEnabled) { return false }
        // let default_value = []
        // let t_value = []
        // if(this.state.selectedColumns){
        //     default_value= this.state.selectedColumns.map(x => x.key)
        //     t_value = this.state.selectedColumns.map(x => x.key)
        // }
        return (
            <div className="d-flex ease-table-column-toggle">
                {/* <label className="d-block m-0">Toggle Columns:</label> */}
                {/* <span className="mt-1">Columns</span> */}
                <Select
                    mode="multiple"
                    style={{ width: '250px' }}
                    maxTagCount={1}
                    placeholder="Select Columns"
                    defaultValue={this.state.selectedColumns.map(x => x.key)}
                    // defaultValue={default_value}
                    value={this.state.selectedColumns.map(x => x.key)}
                    // value={t_value}
                    onChange={this.oncolumnChange}
                    onSelect={(column) => { this.selectAllColumns(column) }}
                    onDeselect={(column) => { this.selectAllColumns(column) }}
                >
                    <Option key={-1} value="select_all">{this.state.allColumnsSelected ? 'Remove All' : 'Select All'}</Option>
                    {
                        this.state.columnMaster.map((column, index) => {
                            return <Option key={index} value={column.key}>{column.title}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }

    render() {
        return this.renderColumnToggleButton(this.props.isEnabled)
    }
}